import { render } from "./PropertiesBar.vue?vue&type=template&id=4ad04298&scoped=true"
import script from "./PropertiesBar.vue?vue&type=script&lang=js"
export * from "./PropertiesBar.vue?vue&type=script&lang=js"

import "./PropertiesBar.vue?vue&type=style&index=0&id=4ad04298&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad04298"]])

export default __exports__